import { FiBell } from 'react-icons/fi'
import { useState, useEffect } from "react"
import api from '../../utils/api'
import NotificationGroups from '../components/NotificationGroups/NotificationGroups'
import './Bell.css'

function Bell() {

    const [token] = useState(localStorage.getItem('token') || '')
    const [notification, setNotification] = useState({ count: 0, groups: [] })

    useEffect(() => {
        api.get(`/notification/getall`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response.data) {
                setNotification(response.data.notification)
            }
        })
    }, [token])

    const count = notification.count || 0

    return (
        <div className="dropdown-notification">
            <li className="dropbtn notif-btn">
                <div className="navbar-bell">
                    <FiBell size={19} />
                    {count > 0 && <span className="navbar-bell-number">{count > 9 ? '9+' : count}</span>}
                </div>
            </li>

            <div className="notif-panel">
                <div className="notif-panel-header">
                    <span>Avisos</span>
                    {count > 0 && <span className="notif-panel-count">{count}</span>}
                </div>

                <NotificationGroups groups={notification.groups} emptyMessage="Nenhum aviso no momento" />
            </div>
        </div>
    )
}

export default Bell
